module.exports = __webpack_public_path__ + "img/round.aab1756e.png";